module.exports = __webpack_public_path__ + "img/261c0a40b2e0e987ef213a43777d0483.png";